import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3497">
      <Navbar data-id="element-3498" />
      <main data-id="element-3499">
        <ConsularAffairs data-id="element-3500" />
      </main>
      <Footer data-id="element-3501" />
    </div>;
}